export const CROP_BOX_SIZE_RATIO = 0.8;
export const ASSERT_PREVIEW_CROP_BOX_SIZE_RATIO = 0.5;
export const FULL_CROP_BOX_SIZE_RATIO = 1;
export const MIN_CROP_SIZE = 50;
export const DRAG_TOLERANCE = 3; // Allow small movement before considering it a drag
export const MIN_DRAG_SIZE = 5; // Minimum size to consider a valid crop
